<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Account' : 'Add Account' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 30px 50px" class="constrained-content">
    <div style="display: flex; flex-direction: column; gap: 14px">
      <div class="notification-preview">
        <div
          class="notification-icon"
          style="width: 56px; height: 56px; border-radius: 8px; border: 1px solid var(--input-border-color)"
        >
          <div
            (click)="uploadIcon()"
            class="icon-upload-button"
            style="
              margin: 0px;
              padding: 0px;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              width: 100%;
              cursor: pointer;
              font-size: 1.4rem;
            "
          >
            <ion-icon name="business-outline" [ngClass]="{ hide: !!imageUrl }"></ion-icon>
            <div *ngIf="imageUrl" class="account-icon-image" [style.background-image]="'url(' + imageUrl + ')'"></div>
          </div>
        </div>
        <div style="flex: 1; margin: 0px">
          <ion-input
            #nameInput
            placeholder="Unthread"
            [(ngModel)]="name"
            class="select-outline"
            style="height: 56px; font-size: 1.4rem"
          >
          </ion-input>
        </div>
      </div>

      <div>
        <div>
          <ion-label class="input-label">
            Primary Support Rep <ion-text color="warning">(Optional)</ion-text>
          </ion-label>
        </div>
        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin-left"
          [outline]="true"
          (click)="showAssigneeOptions(true)"
        >
          <ion-label>
            {{ primarySupportAssignee?.name ?? 'None' }}
            <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
          </ion-label>
        </ion-chip>
      </div>

      <div>
        <div>
          <ion-label class="input-label">
            Secondary Support Rep <ion-text color="warning">(Optional)</ion-text>
          </ion-label>
        </div>
        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin-left"
          [outline]="true"
          (click)="showAssigneeOptions(false)"
        >
          <ion-label>
            {{ secondarySupportAssignee?.name ?? 'None' }}
            <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
          </ion-label>
        </ion-chip>
      </div>

      <div class="separator">
        <div class="input-label-container">
          <ion-label class="input-label">
            Emails and email domains <ion-text color="warning">(Optional)</ion-text>
          </ion-label>
        </div>
        <ion-card class="no-margin">
          <ion-list lines="none" class="no-padding">
            <ion-item *ngIf="emailsAndDomains?.length">
              <ion-label text-wrap>
                <ion-chip
                  outline
                  color="dark"
                  *ngFor="let domain of emailsAndDomains; let i = index"
                  (click)="deleteDomain(i)"
                >
                  <ion-icon name="globe-outline"></ion-icon>
                  <ion-label>{{ domain }}</ion-label>
                </ion-chip>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-input
                placeholder="Add domain (e.g. 'company.com') and hit enter"
                [(ngModel)]="emailDomainToAdd"
                (keyup.enter)="addDomain()"
              ></ion-input>
            </ion-item>
          </ion-list>
        </ion-card>
      </div>

      <div class="separator">
        <div class="input-label-container">
          <ion-label class="input-label"> Slack channels <ion-text color="warning">(Optional)</ion-text> </ion-label>
        </div>

        <ion-card class="no-margin">
          <ion-list lines="none" class="no-padding">
            <ion-item *ngIf="slackChannels?.length">
              <ion-label text-wrap>
                <ion-chip
                  outline
                  color="dark"
                  *ngFor="let channel of slackChannels; let i = index"
                  (click)="removeChannel(i)"
                >
                  <ion-icon name="logo-slack"></ion-icon>
                  <ion-label>{{ channel.name }}</ion-label>
                </ion-chip>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-button (click)="openChannelSelector()" fill="clear">Add Slack channel</ion-button>
            </ion-item>
          </ion-list>
        </ion-card>
      </div>

      <!-- Hidden because people don't yet know what slack teams are -->
      <!-- <div class="separator">
        <div class="input-label-container">
          <ion-label class="input-label"> Slack teams <ion-text color="warning">(Optional)</ion-text> </ion-label>
        </div>

        <ion-card class="no-margin">
          <ion-list lines="none" class="no-padding">
            <ion-item *ngIf="slackTeams?.length">
              <ion-label text-wrap>
                <ion-chip outline color="dark" *ngFor="let team of slackTeams; let i = index" (click)="removeTeam(i)">
                  <ion-icon name="people-circle-outline"></ion-icon>
                  <ion-label>{{ team.name }}</ion-label>
                </ion-chip>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-button (click)="openTeamSelector()" fill="clear">Add Slack team</ion-button>
            </ion-item>
          </ion-list>
        </ion-card>
      </div> -->

      <div class="separator" *ngIf="id && connectedCrm">
        <div class="input-label-container">
          <ion-label class="input-label">
            {{ connectedCrm }} <ion-text color="warning">(Optional)</ion-text>
          </ion-label>
        </div>

        <ion-card class="no-margin">
          <ion-list lines="none" class="no-padding">
            <ion-item *ngIf="externalCrmMetadata?.id" button="true" [href]="externalCrmMetadata.url" target="_blank">
              <ion-icon name="open-outline" class="padded-icon"></ion-icon>
              <ion-label>Open account profile</ion-label>
            </ion-item>
            <ion-item *ngIf="!externalCrmMetadata?.id">
              <ion-button (click)="linkCrm()" fill="clear">Link to account in {{ connectedCrm }}</ion-button>
            </ion-item>
          </ion-list>
        </ion-card>
      </div>

      <div class="separator">
        <div class="input-label-container">
          <ion-label class="input-label"> Custom fields <ion-text color="warning">(Optional)</ion-text> </ion-label>
        </div>

        <ion-card class="no-margin">
          <app-response-input
            *ngIf="customFieldValues"
            [responseInputFields]="customFieldValues"
            [showPublicOption]="false"
            layout="list"
          >
          </app-response-input>
        </ion-card>

        <div class="flex-space-between">
          <ion-button
            fill="clear"
            color="dark"
            class="btn-small"
            (click)="manageCustomFields()"
            *ngIf="authService.isTenantAdmin"
          >
            <ion-icon name="cog-outline" class="padded-icon"></ion-icon>
            Manage custom fields
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <div>
    <ion-button (click)="submit()" [disabled]="isLoading" style="margin-right: 8px">
      <span *ngIf="!isLoading">Save</span>
      <ion-spinner name="crescent" [hidden]="!isLoading"></ion-spinner>
    </ion-button>
    <ion-button (click)="viewInInbox()" fill="clear" color="dark" [disabled]="isLoading">
      <ion-icon name="file-tray-outline"></ion-icon>
      <span class="hidden-sm text-with-left-icon">View conversations</span>
    </ion-button>
  </div>
  <ion-button
    fill="clear"
    color="dark"
    (click)="delete()"
    [disabled]="isLoading"
    *ngIf="id"
    ngxTippy
    data-tippy-content="Delete"
  >
    <ion-icon name="trash-outline"></ion-icon>
  </ion-button>
</ion-footer>

<ion-modal [isOpen]="isShowingCustomFieldsModal" (willDismiss)="onDismissCustomFieldsModal()">
  <ng-template>
    <ion-header>
      <ion-toolbar class="modal-header">
        <div class="modal-title">
          <h3>Manage Custom Attributes</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button fill="clear" shape="round" class="close-button" (click)="onDismissCustomFieldsModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <app-custom-fields
        placeholder="Ex: Plan type"
        [customFields]="customFieldOptions"
        [addCustomFieldButtonLabel]="'Add a custom customer attribute'"
        [showPublicOption]="true"
        [showUserAttributeOption]="false"
      >
      </app-custom-fields>
      <ion-button (click)="updateDefaultCustomFields()" [disabled]="isSavingCustomFields" style="margin: 10px">
        Save
        <ion-spinner name="crescent" style="margin-left: 6px" *ngIf="isSavingCustomFields"></ion-spinner>
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
